import { useLayoutEffect, FC } from 'react';

import AnalyticsService from 'application/services/AnalyticsService';
import { ZVUK_ANALYTIC_ENV, ZVUK_GTM_KEY, ZVUK_GTM_TEST_KEY } from 'application/consts';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

import { GTMWindow } from './types';

const GTM_KEY = ZVUK_ANALYTIC_ENV === 'development' ? ZVUK_GTM_TEST_KEY : ZVUK_GTM_KEY;
const GTM_SITE_URL = `https://www.googletagmanager.com/gtm.js?id=${GTM_KEY}`;
const PROD_COM_HOST_NAME = 'app.zvuk-b2b.com';
const PROD_BY_HOST_NAME = 'app.zvuk-b2b.by';
const DEV_HOST_NAME = 'smartlk-dev-1.zvuk-b2b.com';

const GTM: FC = () => {
  useLayoutEffect(() => {
    const windowGTM: GTMWindow = window;

    windowGTM.dataLayer = windowGTM.dataLayer || [];

    windowGTM.dataLayer.push({
      'gtm.start': DateUtils.NOW.getTime(),
      event: 'gtm.js',
      debugDomain: window.location.hostname,
    });

    const script: HTMLScriptElement = document.createElement('script');
    script.src = GTM_SITE_URL;
    script.async = true;

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return null;
};

const GTMWrapper: FC = () => {
  try {
    const windowGTM: GTMWindow = window;

    const isGTMAvailable =
      !!GTM_KEY &&
      (AnalyticsService.isEnabled ||
        window.location.hostname === PROD_COM_HOST_NAME ||
        window.location.hostname === PROD_BY_HOST_NAME ||
        window.location.hostname === DEV_HOST_NAME);

    if (typeof window !== 'undefined') {
      windowGTM.GTM_DEBUG = {
        available: isGTMAvailable,
        gtmKey: GTM_KEY,
        enabled: AnalyticsService.isEnabled,
        env: ZVUK_ANALYTIC_ENV,
      };
    }

    return isGTMAvailable ? <GTM /> : null;
  } catch (err) {
    console.warn(err);

    return null;
  }
};

export default GTMWrapper;
